import NoSleep from "nosleep.js";
import * as React from "react";
import { IBookOfMindState } from "source/app/presentation/MainPanel/Workflows/BookOfMind/Helpers/IBookOfMindState";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import { ToggleSpeech } from "./ToggleSpeech";
import * as styles from "./SpeechControls.css";

export function StartSpeechLink({
    state,
    whenClicked,
    tooltip = "Speak",
    ariaLabel = "Speak",
}: {
    state: IBookOfMindState;
    whenClicked?: () => void;
    tooltip?: string;
    ariaLabel?: string;
}) {
    const isStarting = state.isSpeechStarting;
    const clickTargetRef = React.useRef<HTMLSpanElement | null>(null);

    React.useEffect(() => {
        const clickTarget = clickTargetRef.current;
        if (!clickTarget) {
            return;
        }

        const noSleep = new NoSleep();
        const enableNoSleep = () => {
            clickTarget.removeEventListener("click", enableNoSleep, false);
            void noSleep.enable().catch(() => {
                // Wake Lock permission is optional; speech can still continue.
            });
        };

        clickTarget.addEventListener("click", enableNoSleep, false);

        return () => {
            clickTarget.removeEventListener("click", enableNoSleep, false);
            noSleep.disable();
        };
    }, []);

    return (
        <span ref={clickTargetRef} id="clickTargetStartSpeechLink">
            <IconWithText
                id="refresh"
                iconSuffix={EGlyphicon.bullhorn}
                whenClicked={() => {
                    if (isStarting) {
                        return;
                    }

                    (whenClicked ?? (() => ToggleSpeech(state)))();
                }}
                displayAsBlock={false}
                withClass={`${styles.controlButton} ${styles.iconOnlyControlButton} ${
                    isStarting
                        ? `${styles.controlButtonActive} ${styles.controlButtonStarting}`
                        : ""
                }`}
                tooltip={isStarting ? "Starting speech" : tooltip}
                ariaLabel={isStarting ? "Starting speech" : ariaLabel}
            />
        </span>
    );
}
